// libs
import styled from 'styled-components'
// components
import { DialogActions, DialogContent } from '@mui/material'
// themes
import { colors } from 'themes/index'
// utils
import { darken } from 'polished'

export const Content = styled(DialogContent)`
  && {
    color: ${colors.gray900};
    overflow-x: visible;
    padding: 24px;
  }
`

export const ActionsWrapper = styled(DialogActions)`
  && {
    background-color: ${colors.gray200};
    border-top: 2px solid ${darken(0.1, colors.gray200)};
    justify-content: flex-start;
    margin: 0;
    padding: 10px 20px;
  }
`

export { default as ContentText } from '@mui/material/DialogContentText'
